import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  continueButton: {
    width: 200,
    height: 50,
    color: "#FFFFFF",
    background: "#7B0000",
    textTransform: "none",
    position: "fixed",
    bottom: 30,
    right: 50,
    zIndex: 10,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    "&:hover": {
      background: "#ff8080",
    },
  },
  inactive: {
    width: 200,
    height: 50,
    color: "#FFFFFF",
    background: "#666666",
    textTransform: "none",
    position: "fixed",
    bottom: 30,
    right: 50,
    zIndex: 10,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    "&:hover": {
      background: "#848484",
    },
  },
}));

const RightBottomButton = ({ navigate, label, style }) => {
  const classes = useStyles();
  return (
    <div>
      {navigate ? (
        <Button
          variant="contained"
          size="medium"
          className={classes.continueButton}
          onClick={navigate}
        >
          {label}
        </Button>
      ) : (
        <Button
          variant="contained"
          size="medium"
          className={classes.inactive}
          style={style ? style : {}}
        >
          {label}
        </Button>
      )}
    </div>
  );
};

export default RightBottomButton;
